var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"light":""}},[(_vm.loggedIn)?_c('navbar'):_vm._e(),_c('v-main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('loading'),_c('toast-alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }